/**
 * Status-helpere for Timetildeling-tabellen. Speiler V3-designprototypen
 * (`statusFor`, `statusColor` i variant3.jsx) og gir en konsistent
 * fargekode/etikett på tvers av oppgavebar, faseband og assignment-rader.
 *
 * Fasering basert på faktisk bruk vs. tildelt:
 *   over          — brukt > 105 % (rød)
 *   tett          — brukt > 85 %  (gul)
 *   paa-vei       — brukt > 0     (grønn)
 *   ikke-startet  — brukt = 0
 *   tom           — tildelt = 0
 */

export type BudgetStatus = "over" | "tett" | "paa-vei" | "ikke-startet" | "tom";

export function statusFor(tildelt: number, brukt: number): BudgetStatus {
  if (tildelt === 0) return brukt > 0 ? "over" : "tom";
  const ratio = brukt / tildelt;
  if (ratio > 1.05) return "over";
  if (ratio > 0.85) return "tett";
  if (ratio > 0) return "paa-vei";
  return "ikke-startet";
}

/** Tailwind background-class for selve bar-fyllingen. */
export const STATUS_BAR_BG: Record<BudgetStatus, string> = {
  over: "bg-destructive",
  tett: "bg-amber-500",
  "paa-vei": "bg-emerald-500",
  "ikke-startet": "bg-muted-foreground/30",
  tom: "bg-muted-foreground/30",
};

/** Tailwind text-class for tall/etikett som skal følge status-fargen. */
export const STATUS_TEXT: Record<BudgetStatus, string> = {
  over: "text-destructive",
  tett: "text-amber-600",
  "paa-vei": "text-emerald-600",
  "ikke-startet": "text-muted-foreground",
  tom: "text-muted-foreground",
};

export function pct(brukt: number, tildelt: number): number {
  if (!tildelt) return 0;
  return Math.min(150, Math.round((brukt / tildelt) * 100));
}
